<template>
  <div>
    <!-- 标题 -->
    <div class="title">
      <div class="title-img">
        <img src="../assets/icon.png" alt="" />
      </div>
      <div class="title-text">
        <span class="text-justyy">木棉树燃气站可视化平台</span>
        <span>Kapok tree gas station visualization platform</span>
      </div>
    </div>
    <div class="time">{{ property }}</div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      property: null,
    };
  },
  mounted() {
    setInterval(() => {
      this.property = moment().format(`YYYY-MM-DD H:mm:ss`);
    }, 1000);
  },
};
</script>
<style lang="less" scoped>
.title {
  width: 25vw;
  height: 5vh;
  position: absolute;
  .Zindex();
  display: flex;
  left: 4%;
  top: 3.2vh;
  .title-img img {
    width: auto;
    height: auto;
    margin-right: 0.5vw;
  }
  .title-text {
    display: flex;
    flex-direction: column;
    .text-justyy {
      .font();
      font-size: 1.8vw;
      color: #fff;
      margin-top: -0.3vh;
    }
  }
  .title-text span:last-child {
    margin-top: -1vh;
    font-size: 0.7vw;
    .font();
    color: rgb(255, 255, 255);
  }
}
.time {
  padding: 0.2vh 0.5vw;
  position: absolute;
  top: 5vh;
  right: 4%;
  .Zindex();
  font-size: 0.8vw;
  color: rgb(255, 255, 255);
}
</style>